import { Injectable, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbAccordionModule,
  NbActionsModule,
  NbAlertModule,
  NbBadgeModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbContextMenuModule,
  NbDatepickerModule,
  NbDialogModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbListModule,
  NbMenuModule,
  NbOptionModule,
  NbPopoverModule,
  NbRadioModule,
  NbRouteTabsetModule,
  NbSelectModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbTabsetModule,
  NbTimepickerModule,
  NbToastrModule,
  NbToggleModule,
  NbTooltipModule,
  NbUserModule,
} from '@nebular/theme';
import { RouterModule } from '@angular/router';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { ThemeSelectorComponent } from './components/theme-selector/theme-selector.component';
import { FacilityLayoutSelectorComponent } from './components/facility-layout-selector/facility-layout-selector.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AlarmLedComponent } from './components/alarm-led/alarm-led.component';
import { AlarmBellComponent } from './components/alarm-bell/alarm-bell.component';
import { StatusLedComponent } from './components/status-led/status-led.component';
import { GlobalSearchComponent } from './components/global-search/global-search.component';
import { TrackingService } from './services/tracking.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SkeletonLoaderComponent } from './components/skeleton-loader/skeleton-loader.component';
import { LicensePlateComponent } from './components/license-plate/license-plate.component';
import { HttpLoaderFactory } from '../app.module';
import { HttpClient } from '@angular/common/http';
import { ActivityChartComponent } from './components/activity-chart/activity-chart.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FilterIdenticalNotificationsPipe } from './pipes/filter-identicalNotifications.pipe';
import { FilterNotificationNamePipe } from './pipes/filter-notificationName.pipe';
import { FilterNotificationPipe } from './pipes/filter-notificationType.pipe';
import { HighlightSearchPipe } from './pipes/highlight-search.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { SortParamsDirective } from './pipes/sortParams.directive';
import { NgbAccordionModule, NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { FeedbackDialogComponent } from './components/feedback/feedback-dialog/feedback-dialog.component';
import { LicensePlateResultComponent } from './components/search/license-plate-result/license-plate-result.component';
import { IdentityCardResultComponent } from './components/search/identity-card-result/identity-card-result.component';
import { ResultDetailsComponent } from './components/global-search/result-details/result-details.component';
import { LicenseplateListComponent } from './components/global-search/licenseplate-list/licenseplate-list.component';
import { CardListComponent } from './components/global-search/card-list/card-list.component';
import { VisitorListComponent } from './components/global-search/visitor-list/visitor-list.component';
import { SubscriberListComponent } from './components/global-search/subscriber-list/subscriber-list.component';
import { ParkerResultComponent } from './components/search/parker-result/parker-result.component';
import { CookieService } from 'ngx-cookie-service';
import { TerminalTitleComponent } from './components/terminal-title/terminal-title.component';
import { DateTimeSelectorComponent } from '../pages/transactions/components/date-time-selector/date-time-selector.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { NbSecurityModule } from '@nebular/security';
import { InfoAlertComponent } from './components/info-alert/info-alert.component';
import { TabPanelComponent } from './components/tab-panel/tab-panel.component';
import { IpTabPanelComponent } from './components/tab-panel/ip-tab-panel/ip-tab-panel.component';
import { IpTabComponent } from './components/tab-panel/ip-tab/ip-tab.component';
import { IpModalComponent } from './components/test-modal/ip-modal/ip-modal.component';
import { LabelRequiredComponent } from './components/label-required/label-required.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { FacilitySelectComponent } from './components/facility-select/facility-select.component';
import { GeneralLedComponent } from './components/general-led/general-led.component';
import { FullStatusLedComponent } from './components/full-status-led/full-status-led.component';
import { CellComponent } from './components/cell/cell.component';
import { InfoComponent } from './components/info/info.component';
import { NotificationsComponent } from './components/notifications/notifications.component';

@Injectable({
  providedIn: 'root',
})
@NgModule({
  declarations: [
    LanguageSelectorComponent,
    ThemeSelectorComponent,
    FacilityLayoutSelectorComponent,
    FeedbackDialogComponent,
    AlarmLedComponent,
    AlarmBellComponent,
    StatusLedComponent,
    GlobalSearchComponent,
    SkeletonLoaderComponent,
    LicensePlateComponent,
    ActivityChartComponent,
    LicensePlateResultComponent,
    IdentityCardResultComponent,
    SortPipe,
    SortParamsDirective,
    FilterNotificationPipe,
    FilterNotificationNamePipe,
    FilterIdenticalNotificationsPipe,
    HighlightSearchPipe,
    ResultDetailsComponent,
    LicenseplateListComponent,
    CardListComponent,
    VisitorListComponent,
    SubscriberListComponent,
    ParkerResultComponent,
    TerminalTitleComponent,
    DateTimeSelectorComponent,
    ConfirmationDialogComponent,
    InfoAlertComponent,
    TabPanelComponent,
    IpTabPanelComponent,
    IpTabComponent,
    IpModalComponent,
    LabelRequiredComponent,
    PageHeaderComponent,
    FacilitySelectComponent,
    GeneralLedComponent,
    FullStatusLedComponent,
    CellComponent,
    InfoComponent,
    NotificationsComponent,
    // VideoPlayerComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    // VgCoreModule,
    // VgControlsModule,
    // VgOverlayPlayModule,
    // VgBufferingModule,
    NbToggleModule,
    ScrollingModule,
    NbLayoutModule,
    NbSidebarModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    RouterModule,
    NbButtonModule,
    NbCardModule,
    NbInputModule,
    NbFormFieldModule,
    NbRadioModule,
    NbCheckboxModule,
    NbContextMenuModule,
    NbTooltipModule,
    NbIconModule,
    NbSelectModule,
    NbOptionModule,
    NbButtonModule,
    NbPopoverModule,
    NbEvaIconsModule,
    NbSelectModule,
    NbOptionModule,
    NbSpinnerModule,
    NbAccordionModule,
    NgbAccordionModule,
    NgbRatingModule,
    NbBadgeModule,
    NbListModule,
    NbMenuModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbToastrModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    TranslateModule.forChild({
      defaultLanguage: 'en-US',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NbTimepickerModule,
    NbActionsModule,
    NbUserModule,
    NbSecurityModule,
    NbAlertModule,
  ],
  exports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    // VgCoreModule,
    // VgControlsModule,
    // VgOverlayPlayModule,
    // VgBufferingModule,
    ScrollingModule,
    NbLayoutModule,
    NbSidebarModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    RouterModule,
    NbButtonModule,
    NbCardModule,
    NbInputModule,
    NbRadioModule,
    NbCheckboxModule,
    NbIconModule,
    NbSelectModule,
    NbOptionModule,
    NbButtonModule,
    NbToggleModule,
    NbPopoverModule,
    NbFormFieldModule,
    NbContextMenuModule,
    NbTooltipModule,
    NbEvaIconsModule,
    NbSelectModule,
    NbOptionModule,
    NbSpinnerModule,
    NbAccordionModule,
    NgbAccordionModule,
    NbBadgeModule,
    NbListModule,
    NbDatepickerModule,
    NbTimepickerModule,
    NbMenuModule,
    NbSidebarModule,
    NbDialogModule,
    NgxEchartsModule,
    LanguageSelectorComponent,
    ThemeSelectorComponent,
    FacilityLayoutSelectorComponent,
    AlarmLedComponent,
    AlarmBellComponent,
    StatusLedComponent,
    GlobalSearchComponent,
    SkeletonLoaderComponent,
    ActivityChartComponent,
    LicensePlateResultComponent,
    IdentityCardResultComponent,
    ParkerResultComponent,
    LicensePlateComponent,
    TranslateModule,
    SortPipe,
    SortParamsDirective,
    FilterNotificationPipe,
    FilterNotificationNamePipe,
    FilterIdenticalNotificationsPipe,
    HighlightSearchPipe,
    TerminalTitleComponent,
    DateTimeSelectorComponent,
    InfoAlertComponent,
    TabPanelComponent,
    IpTabPanelComponent,
    IpTabComponent,
    LabelRequiredComponent,
    PageHeaderComponent,
    FacilitySelectComponent,
    GeneralLedComponent,
    FullStatusLedComponent,
    CellComponent,
  ],
  providers: [TrackingService, CookieService],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [TrackingService],
    };
  }
}
